export default [
  { "id": 1, "name": { "en": "Daily" } },
  { "id": 7, "name": { "en": "Weekly" } },
]